// src/api/suppliers.js
import { apiGet, apiPost, apiPatch, apiDelete } from "lib/apiClient";

export async function listSuppliers({ q = "", limit, offset } = {}) {
    const params = {};
    if (q) params.q = q;
    if (limit !== undefined) params.limit = limit;
    if (offset !== undefined) params.offset = offset;

    const { data, error } = await apiGet("/suppliers/", params);
    if (error) throw new Error(error);

    // Handle paginated response from DRF
    if (data && data.results) {
        return { rows: data.results, count: data.count };
    }
    // Also handle custom pagination { rows, count }
    if (data && data.rows) {
        return { rows: data.rows, count: data.count };
    }
    // Fallback for non-paginated
    return { rows: data || [], count: (data || []).length };
}

export async function getSupplier(id) {
    const { data, error } = await apiGet(`/suppliers/${id}/`);
    if (error) throw new Error(error);
    return data;
}

export async function createSupplier({ name, phone = null, email = null, address = null }) {
    if (!name || !name.trim()) {
        throw new Error("Название поставщика обязательно");
    }

    const payload = {
        name: name.trim(),
    };

    if (phone && phone.trim()) payload.phone = phone.trim();
    if (email && email.trim()) payload.email = email.trim();
    if (address && address.trim()) payload.address = address.trim();

    const { data, error } = await apiPost("/suppliers/", payload);
    if (error) throw new Error(error);
    return data;
}

export async function updateSupplier(id, patch = {}) {
    if (!id) throw new Error("Не указан ID поставщика");

    const payload = {};

    if (patch.name !== undefined) {
        const trimmed = String(patch.name).trim();
        if (!trimmed) throw new Error("Название не может быть пустым");
        payload.name = trimmed;
    }

    if (patch.phone !== undefined) {
        payload.phone = patch.phone ? String(patch.phone).trim() : null;
    }

    if (patch.email !== undefined) {
        payload.email = patch.email ? String(patch.email).trim() : null;
    }

    if (patch.address !== undefined) {
        payload.address = patch.address ? String(patch.address).trim() : null;
    }

    if (patch.contact_info !== undefined) {
        payload.contact_info = patch.contact_info
            ? String(patch.contact_info).trim()
            : null;
    }

    const { data, error } = await apiPatch(`/suppliers/${id}/`, payload);
    if (error) throw new Error(error);
    return data;
}

export async function deleteSupplier(id) {
    if (!id) throw new Error("Не указан ID поставщика");
    const { error } = await apiDelete(`/suppliers/${id}/`);
    if (error) throw new Error(error);
}

export async function getSupplierHistory(id, params = {}) {
    const { data, error } = await apiGet(`/suppliers/${id}/history/`, params);
    if (error) throw new Error(error);
    return data || [];
}

export async function getSupplierItems(id) {
    const { data, error } = await apiGet(`/suppliers/${id}/items/`);
    if (error) throw new Error(error);
    return data || [];
}
